import ServiceLayout from "./ServiceLayout";
import { Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";


const PlantSupply = () => {
  return (
    <>
      <Helmet>
        <title>Plant Supply | KRM Landscape</title>
        <meta
          name="description"
          content="KRM Landscape offers healthy, high-quality plants including ornamental plants, flowering plants, shrubs, and seasonal greenery."
        />
        <meta
          name="keywords"
          content="Plant Supply, KRM Landscape, Healthy Plants, High-Quality Plants, Ornamental Plants, Flowering Plants, Shrubs, Trees, Succulents, Air-Purifying Plants, Seasonal Plants"
        />
      </Helmet>

      <ServiceLayout title="Plant Supply">

        {/* Hero Image */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Box
            component="img"
            src="/images/plants.jpg"
            alt="Plant Supply by KRM Landscape"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxHeight: "400px",
              objectFit: "contain",
              borderRadius: "12px",
              mx: "auto",
              display: "block",
            }}
          />
        </Box>

        <Typography paragraph>
          At KRM Landscape, our plant supply services focus on providing healthy,
          high-quality plants that enhance both indoor and outdoor environments.
          We carefully select plants that thrive in local conditions while
          complementing the aesthetic of your space.
        </Typography>

        <Typography paragraph>
          Our extensive collection includes ornamental plants, flowering plants,
          shrubs, trees, succulents, air-purifying plants, and seasonal varieties.
          Whether you are designing a home garden, office interior, terrace,
          or large-scale landscape project, we offer plants suited to every need.
        </Typography>

        <Typography paragraph>
          Each plant is responsibly sourced and nurtured under proper conditions
          to ensure strong root systems, healthy growth, and long-lasting beauty.
          We also provide expert guidance on plant selection, placement, and care
          to help your greenery flourish over time.
        </Typography>

        <Typography paragraph>
          With KRM Landscape’s plant supply services, you don’t just receive plants,
          you receive living elements that bring freshness, balance, and natural
          beauty into your surroundings.
        </Typography>

      </ServiceLayout>
    </>
  );
};

export default PlantSupply;
